import { LibService } from './libService';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PaymentMethodService {

  baseApi = environment.rootApiPaperwork;

  constructor(
    public libService: LibService,
  ) { }

  getBySocietyAndBusinessLine(societyIds: Array<any>, businessLineIds: Array<any>): Observable<any> {
    return this.libService.postData<any>(
      {
        businessLineIds : businessLineIds,
        societyIds: societyIds
      },
      this.baseApi, 
      'paymentMethods/getBySocietyAndBusinessLine'
      );
  }

    getBySocietyAndBusinessLineAndPractice(societyIds: Array<any>, businessLineIds: Array<any>, practiceId: any): Observable<any> {
    return this.libService.postData<any>(
      {
        businessLineIds : businessLineIds,
        societyIds: societyIds,
        practiceId: practiceId
      },
      this.baseApi, 
      'paymentMethods/getBySocietyAndBusinessLineAndPractice'
      );
  }

}
